import { DueDisplayOptions, Task, Timestamp, WeekDays } from '@griply/types';
import { getTaskDueAndTimeslot, TaskDueAndTimeslot } from '@griply/utils';
import { useMemo } from 'react';

const allDueDisplayOptions = Object.values(DueDisplayOptions);

export type UseTaskDueAndTimeslotOptions = {
  today: Timestamp;
  weekStartsOn: WeekDays;
  displayDate?: Timestamp;
  displayDue?: DueDisplayOptions[];
};

export type { TaskDueAndTimeslot };

export const useTaskDueAndTimeslot = (
  task: Task,
  {
    today,
    weekStartsOn,
    displayDate,
    displayDue = allDueDisplayOptions,
  }: UseTaskDueAndTimeslotOptions,
): TaskDueAndTimeslot =>
  useMemo(
    () =>
      getTaskDueAndTimeslot(task, {
        today,
        weekStartsOn,
        displayDate,
        displayDue,
      }),
    [task, today, weekStartsOn, displayDate, displayDue],
  );
